export const Colours = {
    border: "#16181a",

    highlightText: "#fff",
    
    blueHighlightBg: "#2d9cfc",
    blueHighlightBgHover: "#89c7fe",
    blueHighlightText: "#fff",

    orangeHighlightBg: "#fda140",
    orangeHighlightText: "#fff",

    levelZeroBg: "#000000",
    levelZeroText: "#4d4d4d",

    levelOneBg: "#111318",
    levelOneText: "#5d5d5d",
    
    levelTwoBg: "#212836ff",
    levelTwoText: "#a1a1a1",

    levelThreeBg: "#2b4264ff",
    levelThreeText: "#b3b3b3",

    levelFourBg: "#496fa7",
    levelFourText: "#fff",
    
    panelTitleBg: "#d78f3f",
    panelTitleText: "#333",

    connected:"green",
    connectionAvailable: "#155db0",
    notConnected: "#ff591a",
};